export default "__VITE_ASSET__a555fba2__"